export const QA_NAME_CALENDAR_GRID_CHIP = 'calendarGridChip'
